// src/components/AppSnackbar.js
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert, Typography } from '@mui/material';
import { HIDE_SNACKBAR } from '../constants/actionTypes';

const AppSnackbar = () => {
  const dispatch = useDispatch();
  const snackbar = useSelector((state) => state.ui?.snackbar || {});
  const raw = snackbar.message || "";
  const [title, body] = raw.split(" - ", 2);

  const borderColor = {
  error: '#EF5350',    
  warning: '#ed7321',  
  info: '#ffc800',     
  success: '#EDF7ED',  
  expiry:'#ef5350'
};

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    dispatch({ type: HIDE_SNACKBAR });
  };

  if (!snackbar) return null;

  const border = borderColor[snackbar.severity] || borderColor.info;

  return (
    <Snackbar
      open={!!snackbar.open}
      autoHideDuration={8000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right', borderRadius:'10px' }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar?.severity}
        variant="filled"
        sx={{ cursor: 'pointer', borderRadius:'10px', color:'#fff', background: 'white', border:`1px solid ${border}`,
        borderLeft:`15px solid ${border}`, boxShadow:'0px 1px 18px 0px rgba(0,0,0,0.3),',
        '& .MuiAlert-icon': {
    fontSize: '36px',      // icon size
       // spacing between icon + text
    opacity: 1,
    margin:'auto',
    background:`${border} !important`,
    padding:'5px',
    color:'white',
    borderRadius:'50%',
    marginRight: '12px',
  },
  '& .MuiAlert-action': {
    color: '#000 !important',   // ← close icon wrapper
  },
  '& .MuiAlert-action .MuiSvgIcon-root': {
    color: '#000 !important',   // ← actual X icon
    fontSize: '20px',
  },
  '& .MuiAlert-icon .MuiSvgIcon-root': {
  paddingBottom: snackbar.severity === 'warning' ? '4px' : '0px',
},
 '& .MuiAlert-message': {
    color: '#333',            // ← THIS is the key
  },
}}
      >
        {body ? (
  <Typography variant='body2' sx={{color:'#333', fontWeight:600}}>
    <strong style={{fontSize:'16px'}}>{title}</strong>
    <br />
    {body}
  </Typography>
) : (
  raw
)}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbar;

